// src/UI/ActionsMenu/ActionsMenu.tsx
import React, { useState } from "react";
import MoreVertIcon from "@mui/icons-material/MoreVert";

// Импортируем наши стилизованные компоненты
import {
  StyledIconButton,
  StyledMenu,
  StyledMenuItem
} from "./style.ts";

interface ActionsMenuProps {
  onDelete?: () => void;
  onPrint?: () => void;
  onExport?: () => void;
}

const ActionsMenu: React.FC<ActionsMenuProps> = ({
  onDelete,
  onPrint,
  onExport
}) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  // Открываем меню
  const handleOpen = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  // Закрываем меню
  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <StyledIconButton onClick={handleOpen}>
        <MoreVertIcon />
      </StyledIconButton>

      <StyledMenu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
        anchorOrigin={{ vertical: "top", horizontal: "left" }}
        transformOrigin={{ vertical: "top", horizontal: "left" }}
      >
        <StyledMenuItem
          onClick={() => {
            handleClose();
            onDelete?.();
          }}
        >
          Удалить
        </StyledMenuItem>

        <StyledMenuItem
          onClick={() => {
            handleClose();
            onPrint?.();
          }}
        >
          Распечатать
        </StyledMenuItem>

        <StyledMenuItem
          onClick={() => {
            handleClose();
            onExport?.();
          }}
        >
          Экспортировать
        </StyledMenuItem>
      </StyledMenu>
    </>
  );
};

export default ActionsMenu;
